<template>
  <div class="table-wrapper">
    <el-table
      :data="data"
      stripe
      style="width: 100%"
      size="medium"
      header-row-class-name="common-table-header"
      row-class-name="common-table-row"
      class="is-print-hide common-table"
      :border="false"
      :row-key="getRowKeys"
      @selection-change="handleSelectionChange"
      @select="handleSelect"
      @select-all="handleSelectAll"
    >
      <el-table-column type="selection" width="55" :reserve-selection="true"></el-table-column>
      <el-table-column prop="storeName" label="门店">
        <template #default="{ row: { storeName } }">
          <el-tooltip class="item" effect="dark" :open-delay="500" :content="storeName" placement="top">
            <span class="store-name">
              {{ storeName }}
            </span>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column prop="storeManagerName" label="店长"></el-table-column>
      <el-table-column prop="serverTypeDescription" label="服务类型"></el-table-column>
      <el-table-column prop="serverExpireTime" label="年费服务到期时间"></el-table-column>
      <el-table-column prop="serverStatus" label="年费服务状态">
        <template #default="{ row: { serverStatus } }">
          <span :class="{ 'expire-warning': [EXPIRE_SOON, EXPIRED].indexOf(serverStatus) > -1 }">
            {{ serverStatus | constOptions(serverStatusOption) }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-wrapper">
      <el-pagination
        class="is-print-hide common-el-pagination"
        layout="prev, pager, next, total, jumper, sizes"
        :total="total"
        :current-page="pageNo"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        @current-change="val => $emit('handle-pageNo', val)"
        @size-change="val => $emit('handle-pageSize', val)"
      />
      <div class="sureJump global_common_button_goast">确定</div>
    </div>
  </div>
</template>

<script>
import { SERVER_STATUS, serverStatusOption } from '@/lib/constant';
import { constOptions } from '@/util';

export default {
  name: 'renewalStoreTable',
  props: {
    data: {
      type: Array
    },
    total: {
      type: Number
    },
    pageNo: {
      type: Number
    },
    pageSize: {
      type: Number,
      default: 10
    },
    pageSizes: {
      type: Array
    }
  },
  data() {
    return {
      ...SERVER_STATUS,
      getRowKeys(row) {
        return row.storeId;
      },
      multipleSelection: [],
      serverStatusOption
    };
  },
  methods: {
    handleSelectionChange(rows) {
      this.$emit('handle-selection-change', rows);
    },
    handleSelect(selection, row) {
      this.$emit('handle-select', selection, row);
    },
    handleSelectAll(selection) {
      this.$emit('handle-select-all', selection);
    }
  },
  filters: {
    constOptions
  }
};
</script>

<style lang="scss" scoped>
.btn {
  color: #1e8dff;
  font-size: 12px;
  cursor: pointer;

  & + .btn {
    margin-left: 5px;
  }
}

.pagination-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 22px;

  /deep/.el-pagination {
    margin-top: 0;
    overflow-x: auto;
  }

  .sureJump {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    margin-left: 10px;
    width: 80px;
    min-width: 80px;
    height: 32px;
    border-radius: 3px;
    cursor: pointer;
  }
}
.expire-warning {
  color: #df3933;
}
</style>
